import enTranslation from '../lang/en.json';
import indTranslation from '../lang/ind.json';

export default {
    en: {
        name: "en",
        text: "English",
        langJson: enTranslation
    },
    ind: {
        name: "ind",
        text: "Indonesia",
        langJson: indTranslation
    }
};
